$(function() {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('ul > li > button');
    var break_point = 1300;
    var browser_width = window.innerWidth;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');
    var standard_nav_trigger = $('.menuTrigger');
    var megamenu_trigger = $('.megamenuTrigger');
    var submenu_trigger = $('.submenuTrigger');
    var megamenu = $('.megamenu');
    var megamenu_close = $('.megamenuClose')
    var search_desktop = $('.searchbar __header');
    var search_mobile = $('.searchbar __mobile');

    nav_window.click(function(event) {
        nav_reset();
    });

    //burger click
    burger.click(function(event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    megamenu_close.click(function(event) {
        $(this).parents().parents(megamenu).removeClass('__active').find('a', 'button').attr('tabindex', '-1');
        $(this).parents().parents(megamenu).siblings(megamenu_trigger).removeClass('__active');
        $(this).parents().parents(megamenu).focus().attr('aria-expanded', 'false')
        $('.header-wrapper').removeClass('__megamenu-active');
    })

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (browser_width < break_point) {
                nav_reset();
                burger.focus();
            } else {
                standard_nav_trigger.removeClass('__active').attr('aria-expanded', 'false');
                standard_nav_trigger.siblings('ul').removeClass('__active');
                standard_nav_trigger.parents('li').removeClass('__active');
                megamenu.removeClass('__active').find('a', 'button').attr('tabindex', '-1');
                megamenu_trigger.removeClass('__active');
                megamenu.attr('aria-expanded', 'false');
                $('.header-wrapper').removeClass('__megamenu-active');
            }
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, .megamenu').removeClass('__active');
        search_mobile.find('input', 'button').attr('tabindex', '-1');
        megamenu.find('a', 'button').attr('tabindex', '-1');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
        search_mobile.find('input', 'button').attr('tabindex', '0');
        megamenu.find('a', 'button').attr('tabindex', '0');
    };

    function initMenu() {
        var browser_width = window.innerWidth;
        search_mobile.find('input', 'button').attr('tabindex', '-1');
        megamenu.find('a', 'button').attr('tabindex', '-1');

        // nav dropdown on focus/keyboard navigation
        $('.menu-item').focusin(function() {
            $(this).addClass('__active');
        });
        $('.menu-item').focusout(function() {
            $(this).removeClass('__active');
        });

        if (browser_width >= break_point) {

            standard_nav_trigger.click(function (event) {
                if ($(this).hasClass('__active')) {
                    $(this).removeClass('__active').attr('aria-expanded', 'false');
                    $(this).siblings('ul').removeClass('__active');
                    $(this).parents('li').removeClass('__active');
                }

                else {
                    $(this).addClass('__active').attr('aria-expanded', 'true');
                    $(this).siblings('ul').addClass('__active');
                    $(this).parents('li').addClass('__active');
                    $(this).parents('li').siblings('li').removeClass('__active');
                    $(this).parents('li').siblings('li').children('button').removeClass('__active');
                    $(this).parents('li').siblings('li').children(megamenu).removeClass('__active');
                    $('.header-wrapper').removeClass('__megamenu-active');
                }
            });

            megamenu_trigger.click(function() {
                if ($(this).hasClass('__active')) {
                    $(this).removeClass('__active').attr('aria-expanded', 'false');
                    $(this).siblings(megamenu).removeClass('__active').find('a', 'button').attr('tabindex', '-1');
                    $(this).parents().removeClass('__active');
                    $('.header-wrapper').removeClass('__megamenu-active');
                }

                else {
                    $(this).addClass('__active').attr('aria-expanded', 'true');
                    $(this).siblings(megamenu).addClass('__active').find('a', 'button').attr('tabindex', '0');
                    $(this).parents('li').siblings('li').children('button').removeClass('__active');
                    $(this).parents('li').siblings('li').children(megamenu).removeClass('__active');
                    $('.header-wrapper').addClass('__megamenu-active');
                }
            });

            megamenu_trigger.keypress(function() {
                if ($(this).attr('aria-expanded', 'false')) {
                    $(this).siblings(megamenu).find(megamenu_close).focus();
                }
            })
        };

        if (browser_width < break_point) {
            search_desktop.find('input', 'button').attr('tabindex', '0');
            standard_nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).siblings('ul').length > 0) {
                    event.preventDefault();
                    $(this).parents('ul').removeClass('__active');
                    $(this).siblings('ul').addClass('__active');
                    $(this).siblings('ul').children('ul').removeClass('__active')
                }
            });

            megamenu_trigger.click(function(event) {
                event.stopPropagation();
                if ($(this).siblings('.megamenu').length > 0) {
                    event.preventDefault();
                    $(this).parents('ul').removeClass('__active');
                    $(this).siblings('.megamenu').addClass('__active');
                    $(this).siblings('ul').children('ul').removeClass('__active')
                }
            });

            submenu_trigger.click(function(event) {
                event.stopPropagation();
                $(this)
                    .closest('.megamenu-title-wrap')
                    .siblings('.megamenu-list')
                    .slideToggle();
                $(this)
                    .toggleClass('__active');
            });

            var back_menu = $('.backto');
            back_menu.click(function (event) {
                $(this)
                    .parents('.childMenu, .megamenu')
                    .removeClass('__active');
                $(this)
                    .parents('.childMenu, .megamenu')
                    .parent('li')
                    .parent('ul')
                    .addClass('__active');
            });
        }

        else {
            nav_reset();
        }
    };

    initMenu();

    if (browser_width > break_point) {
        $(document).click(function(e) {
            const target = e.target;

            if (!target.closest('.menu-item')) {
                nav_reset();
                $('.header-wrapper').removeClass('__megamenu-active');
                $('.megamenuTrigger').removeClass('__active');
                $('.menuTrigger').removeClass('__active');
            }
        })
    }
});
